export default "__VITE_ASSET__DupvfxRL__"